import { render, staticRenderFns } from "./InspectorFields.vue?vue&type=template&id=4fbc5bb9&scoped=true&"
import script from "./InspectorFields.vue?vue&type=script&setup=true&lang=js&"
export * from "./InspectorFields.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./InspectorFields.vue?vue&type=style&index=0&id=4fbc5bb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbc5bb9",
  null
  
)

export default component.exports